import { useSelector } from "react-redux";
import {
  ProgressBarLine,
  TrackProgressBar as StyledTrackProgressBar,
} from "./styled";

export const TrackProgressBar = ({ trackOrReleaseId }) => {
  const { progress, duration, currentContent, audioType } =
    useSelector((state) => {
      if (state.player.currentContent?.id === trackOrReleaseId) {
        return state.player;
      }
      return;
    }) || {};

  if (trackOrReleaseId !== currentContent?.id) return <ProgressBarLine />;

  const progressPercentage = (progress / duration) * 100;

  return (
    <StyledTrackProgressBar
      style={{
        "--progress": `${audioType === "stream" ? 100 : progressPercentage}%`,
      }}
    />
  );
};
